export default "__VITE_ASSET__d7eEsrx8__"